module.exports = __webpack_public_path__ + "img/6.b629b1c0.jpg";